/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';
import { useState } from 'react';
import { Button, Card, CardContent, Dialog, DialogActions, FormControl, FormControlLabel, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { formatDateForInput } from 'utilities/common';
import SpinnerComponent from 'modules/common/spinner.component';
import { getClientRelocationPoliciesByClientId, postClientRelocationPolicy, updateClientRelocationPolicy } from 'modules/clients/clients.actions';
import { showToast } from 'modules/layout/layout.actions';
import { GET_CLIENT_RELO_POLICIES_BY_CLIENT_ID_FAILURE, POST_CLIENT_RELO_POLICY_FAILURE } from 'modules/clients/types';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  {
    id: 'policyCode',
    numeric: false,
    disablePadding: true,
    label: 'Policy Code',
  },
  {
    id: 'policyDescription',
    numeric: true,
    disablePadding: false,
    label: 'Policy Description',
  },
  {
    id: 'policyAssignmentTypeId',
    numeric: true,
    disablePadding: false,
    label: 'Policy Type',
  },
  {
    id: 'clientBillingPolicyId',
    numeric: true,
    disablePadding: false,
    label: 'Billing Policy',
  },
  {
    id: 'associatedDivisions',
    numeric: true,
    disablePadding: false,
    label: 'Divisions',
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

function EnhancedTableToolbar(props) {
  return (
    <Toolbar
      sx={[
        {
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
        },
      ]}
    >

        <Typography
          sx={{ 
            flex: '1 1 100%',
            fontSize: '1.3125rem',
            fontWeight: 'bold'
          }}
          variant="h5"
          id="tableTitle"
          component="div"
        >
          Relocation Policies
        </Typography>

        <Tooltip title="Filter list">
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
    </Toolbar>
  );
}

function ClientRelocationPolicyTable(props) {
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('calories');
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [showInactivePolicies, setShowInactivePolicies] = useState(false);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [isPolicyValid, setIsPolicyValid] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [isChoosingCreationMethod, setIsChoosingCreationMethod] = useState(true);

  const [policyCode, setPolicyCode] = useState('');
  const [policyDescription, setPolicyDescription] = useState('');
  const [policyCap, setPolicyCap] = useState(0);
  const [clientPolicyStatusId, setClientPolicyStatusId] = useState('00000000-0000-0000-0000-000000000000');
  const [clientBillingPolicyId, setClientBillingPolicyId] = useState(null);
  const [associatedDivisions, setAssociatedDivisions] = useState('');
  const [policyAssignmentTypeId, setPolicyAssignmentTypeId] = useState('00000000-0000-0000-0000-000000000000');
  const [effectiveStart, setEffectiveStart] = useState(null);
  const [effectiveEnd, setEffectiveEnd] = useState(null);
  const [isPolicyCapped, setIsPolicyCapped] = useState(false);
  const [isRepayAgreementRequired, setIsRepayAgreementRequired] = useState(false);
  const [isCostEstimateRequired, setIsCostEstimateRequired] = useState(false);

  const [servicesToCopy, setServicesToCopy] = useState([]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected.push(id);
      props.newReloPolicySelected(id); // policy.relocationPolicyId
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      //newSelected = newSelected.concat(
       // selected.slice(0, selectedIndex),
       // selected.slice(selectedIndex + 1),
     // );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filteredPolicies = React.useMemo(
    () => (props.clientReloPolicies || []).filter(({ policy }) => {
      const statusId = policy.clientRelocationPolicyStatusId ?? policy.clientPolicyStatusId;
      const statusTitle = props.enumerations.clientPolicyStatuses?.find(status => status.id === statusId)?.title;
      const status = String(statusTitle || statusId).toLowerCase();
      return status === 'active' || (showInactivePolicies && status === 'inactive');
    }),
    [props.clientReloPolicies, props.enumerations.clientPolicyStatuses, showInactivePolicies],
  );
  const currentPage = Math.min(page, Math.max(0, Math.ceil(filteredPolicies.length / rowsPerPage) - 1));

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    currentPage > 0 ? Math.max(0, (1 + currentPage) * rowsPerPage - filteredPolicies.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      [...filteredPolicies]
        .sort(getComparator(order, orderBy))
        .slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage),
    [filteredPolicies, order, orderBy, currentPage, rowsPerPage],
  );

  const createPolicy = async () => {
    const selectedDivision = props.clientDivisions?.find(division => String(division.clientDivisionId) === associatedDivisions);
    if (associatedDivisions && !selectedDivision) {
      props.showToast('Selected division is no longer available.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return false;
    }

    setIsLoadingModal(true);

    let newPolicyServices = [];

    if (servicesToCopy && servicesToCopy.length > 0) {
      servicesToCopy.forEach((service) => {
        let newPolicyBenefits = [];

        service.policyBenefits.forEach((benefit) => {
          let newPolicyBenefitOptions = [];

          benefit.policyBenefitOptions.forEach((option) => {
            newPolicyBenefitOptions.push({
              policyBenefitOptionId: undefined,
              policyBenefitId: undefined,
              staticPolicyBenefitOptionId: option.staticPolicyBenefitOptionId,
              optionValue: option.optionValue
            });
          });

          newPolicyBenefits.push({
            policyBenefit: {
              policyBenefitId: undefined,
              policyServiceId: undefined,
              staticPolicyBenefitId: benefit.policyBenefit.staticPolicyBenefitId,
              isActive: benefit.policyBenefit.isActive
            },
            policyBenefitOptions: newPolicyBenefitOptions
          });
        });

        newPolicyServices.push({
          policyService: {
            policyServiceId: undefined,
            clientRelocationPolicyId: undefined,
            staticPolicyServiceId: service.policyService.staticPolicyServiceId,
            isActive: service.policyService.isActive
          },
          policyBenefits: newPolicyBenefits
        });
      });
    }

    const newPolicy = {
      policy: {
        clientRecordId: props.clientRecordId,
        policyCode: policyCode,
        policyDescription: policyDescription,
        policyCap: policyCap,
        clientPolicyStatusId: clientPolicyStatusId,
        clientBillingPolicyId: clientBillingPolicyId,
        policyAssignmentTypeId: policyAssignmentTypeId,
        effectiveStart: effectiveStart ? formatDateForInput(effectiveStart) : null,
        effectiveEnd: effectiveEnd ?  formatDateForInput(effectiveEnd) : null,
        isPolicyCapped: isPolicyCapped,
        isRepayAgreementRequired: isRepayAgreementRequired,
        isCostEstimateRequired: isCostEstimateRequired,
        addedBy: 1,
        addedOn: new Date(),
        modifiedBy: 1,
        modifiedOn: new Date()
      },
      policyDivisions: selectedDivision ? [selectedDivision] : [],
      policyServices: newPolicyServices
    }

    const resp = await props.postClientRelocationPolicy(newPolicy);
    if (resp.type === POST_CLIENT_RELO_POLICY_FAILURE) {
        showToast('Failed to save policy, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        setIsLoadingModal(false);
        return false;
    } else {
        const getResp = await props.getClientRelocationPoliciesByClientId(props.clientRecordId);
        if (getResp.type === GET_CLIENT_RELO_POLICIES_BY_CLIENT_ID_FAILURE) {
            setIsLoadingModal(false);
            return false;
        } else {
            setIsLoadingModal(false);
            setCreateModalOpen(false);
          
            props.showToast('Successfully saved policy changes.', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });

            setPolicyCode('');
            setPolicyDescription('');
            setPolicyCap(0);
            setClientPolicyStatusId('00000000-0000-0000-0000-000000000000');
            setClientBillingPolicyId(null);
            setAssociatedDivisions('');
            setPolicyAssignmentTypeId('00000000-0000-0000-0000-000000000000');
            setEffectiveStart(null);
            setEffectiveEnd(null);
            setIsPolicyCapped(false);
            setIsRepayAgreementRequired(false);
            setIsCostEstimateRequired(false);
            setServicesToCopy([]);
            return true;
        }
    }
  }

  React.useEffect (() => {
    if (policyCode && policyCode.length > 0 && policyDescription && policyDescription.length > 0 && clientPolicyStatusId && policyAssignmentTypeId && clientBillingPolicyId) {
      setIsPolicyValid(true);
    }
  }, [policyCode, policyDescription, clientPolicyStatusId, policyAssignmentTypeId, clientBillingPolicyId]);

  React.useEffect(() => {
    if (props.billingPolicySelected) setSelected([]);
  }, [props.billingPolicySelected]);

  return (
    <Box sx={{ width: '100%', padding: '10px' }}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <EnhancedTableToolbar numSelected={selected.length} />

        <Box sx={{ paddingLeft: '16px', display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
          <Button color="primary" onClick={() => setCreateModalOpen(true)} variant="contained">
            Add Policy
          </Button>
          <FormControlLabel
            label="Show Inactive Policies"
            control={
              <Checkbox
                checked={showInactivePolicies}
                onChange={event => {
                  setShowInactivePolicies(event.target.checked);
                  setPage(0);
                }}
              />
            }
          />
        </Box>

        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={'medium'}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={filteredPolicies.length}
            />
            <TableBody>
              {visibleRows.map((row, index) => {
                const isItemSelected = selected.includes(row.policy.relocationPolicyId);
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow
                    hover
                    onClick={(event) => handleClick(event, row.policy.relocationPolicyId)}
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.id}
                    selected={isItemSelected}
                    sx={{ cursor: 'pointer' }}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        color="primary"
                        checked={isItemSelected}
                        inputProps={{
                          'aria-labelledby': labelId,
                        }}
                      />
                    </TableCell>
                    <TableCell
                      component="th"
                      id={labelId}
                      scope="row"
                      padding="none"
                    >
                      {row.policy.policyCode}
                    </TableCell>
                    <TableCell align="right">{row.policy.policyDescription}</TableCell>
                    <TableCell align="right">{props.enumerations.policyAssignmentTypes.find((pat) => pat.id === row.policy.policyAssignmentTypeId).title}</TableCell>
                    <TableCell align="right">{row.policy.clientBillingPolicyId}</TableCell>
                    <TableCell align="right">{row.policyDivisions?.map(division =>
                      props.clientDivisions?.find(clientDivision => clientDivision.clientDivisionId === division.clientDivisionId)?.divisionName || division.clientDivisionId
                    ).join(', ')}</TableCell>
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredPolicies.length}
          rowsPerPage={rowsPerPage}
          page={currentPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      <Dialog open={createModalOpen} fullWidth={true} maxWidth={'xl'}>
        <Box sx={{ padding: '20px' }}>
          <Box>
            <Typography variant="h6" gutterBottom>
              Create New Relocation Policy
            </Typography>
            {isChoosingCreationMethod && (
              <Typography variant="body1" gutterBottom>Chose one of the following methods to create a new relocation policy:</Typography>
            )}
          </Box>
          {isChoosingCreationMethod && (
            <Grid container spacing={2}>
              <Grid item md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Create from Existing Policy
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                      Create a new relocation policy by copying the details from an existing relocation policy.
                    </Typography>

                    <Box>
                      {props.clientReloPolicies.map((policy) => (
                        <Box sx={{ marginTop: '10px' }} key={policy.policy.relocationPolicyId}>
                          <Button
                            variant="outlined"
                            onClick={() => {
                              setIsChoosingCreationMethod(false);
                              // Copy existing policy details into state variables
                              setPolicyCode('');
                              setPolicyDescription(`Copy of ${policy.policy.policyDescription}`);
                              setPolicyCap(policy.policy.policyCap);
                              setClientPolicyStatusId(policy.policy.clientPolicyStatusId);
                              setClientBillingPolicyId(policy.policy.clientBillingPolicyId);
                              setAssociatedDivisions(String(policy.policyDivisions?.[0]?.clientDivisionId ?? ''));
                              setPolicyAssignmentTypeId(policy.policy.policyAssignmentTypeId);  
                              setEffectiveStart(policy.policy.effectiveStart || '');
                              setEffectiveEnd(policy.policy.effectiveEnd || '');
                              setIsPolicyCapped(policy.policy.isPolicyCapped || false);
                              setIsRepayAgreementRequired(policy.policy.isRepayAgreementRequired || false);
                              setServicesToCopy(policy.policyServices || []);
                            }}
                          >
                            <Box>
                              {policy.policy.policyDescription} ({policy.policy.policyCode}) - {props.enumerations.policyAssignmentTypes.find((pat) => pat.id === policy.policy.policyAssignmentTypeId).title}
                            </Box>
                          </Button>
                        </Box>
                      ))}
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Create New Policy
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                      Start with a blank policy and configure benefits individually.
                    </Typography>

                    <Box>
                      <Box sx={{ marginTop: '10px' }}>
                        <Button
                          variant="outlined"
                          color="secondary"
                          onClick={() => {
                            setIsChoosingCreationMethod(false);
                          }}
                        >
                          Create Blank Policy
                        </Button>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )}
          {!isChoosingCreationMethod && (
              <Grid container spacing={2}>
                <Grid item md='3'>
                    <TextField
                        label="Relo Policy Code"
                        name="reloPolicyCode"
                        value={policyCode}
                        margin="dense"
                        sx={{ maxWidth: '360px' }}
                        variant="standard"
                        type="text"
                        onChange={(e) => { setPolicyCode(e.target.value); }}
                    />
                </Grid>
                <Grid item md='3'>
                    <TextField
                        label="Relo Policy Description"
                        name="policyDescription"
                        value={policyDescription}
                        margin="dense"
                        sx={{ maxWidth: '360px' }}
                        variant="standard"
                        type="text"
                        onChange={(e) => { setPolicyDescription(e.target.value); }}
                    />
                </Grid>
                <Grid item md='3'>
                    <TextField
                        label="Policy Cap"
                        name="policyCap"
                        value={policyCap}
                        margin="dense"
                        sx={{ maxWidth: '360px' }}
                        variant="standard"
                        type="number"
                        InputProps={{
                            startAdornment: <InputAdornment position="start">$</InputAdornment>
                        }}
                        allowDecimal
                        onChange={(e) => { setPolicyCap(e.target.value); }}
                    />
                </Grid>
                <Grid item md='3'>
                    <FormControl sx={{ marginTop: '6px' }}>
                        <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }}>Relo Policy Status</InputLabel>
                        <Select
                            label="Currency"
                            name="clientPolicyStatusId"
                            value={clientPolicyStatusId}
                            variant="standard"
                            sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                            onChange={(e) => { setClientPolicyStatusId(e.target.value); }}
                        >
                            {props.enumerations.clientPolicyStatuses.map(opt => (
                                <MenuItem key={opt.id} value={opt.id}>
                                    {opt.title}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item md='3'>
                    <FormControl sx={{ marginTop: '6px' }}>
                        <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }}>Billing Policy</InputLabel>
                        <Select
                            label="Currency"
                            name="clientBillingPolicyId"
                            value={clientBillingPolicyId}
                            variant="standard"
                            sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                            onChange={(e) => { setClientBillingPolicyId(e.target.value); }}
                        >
                            {props.billingPolicies.map(opt => (
                                <MenuItem key={opt.billingPolicy.billingPolicyId} value={opt.billingPolicy.billingPolicyId}>
                                    {opt.billingPolicy.billingPolicyDescription}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item md='3'>
                    <FormControl sx={{ marginTop: '6px' }}>
                        <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }}>Divisions</InputLabel>
                        <Select
                            label="Divisions"
                            name="divisions"
                            value={associatedDivisions}
                            variant="standard"
                            sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                            onChange={(e) => { setAssociatedDivisions(e.target.value); }} 
                        >
                            {(props.clientDivisions || []).map(division => (
                              <MenuItem key={division.clientDivisionId} value={String(division.clientDivisionId)}>
                                {division.divisionName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item md='3'>
                    <FormControl sx={{ marginTop: '6px' }}>
                        <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }}>Policy Type</InputLabel>
                        <Select
                            label=""
                            name="policyAssignmentTypeId"
                            value={policyAssignmentTypeId}
                            variant="standard"
                            sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                            onChange={(e) => { setPolicyAssignmentTypeId(e.target.value); }}
                        >
                            {props.enumerations.policyAssignmentTypes.map(opt => (
                                <MenuItem key={opt.id} value={opt.id}>
                                    {opt.title}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item md='3'>
                    <TextField
                        label="Effective Start"
                        name="effectiveStart"
                        value={formatDateForInput(effectiveStart)}
                        margin="dense"
                        sx={{ maxWidth: '360px' }}
                        variant="standard"
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => { setEffectiveStart(e.target.value); }}
                    />
                </Grid>
                <Grid item md='3'>
                    <TextField
                        label="Effective End"
                        name="effectiveEnd"
                        value={formatDateForInput(effectiveEnd)}
                        margin="dense"
                        sx={{ maxWidth: '360px' }}
                        variant="standard"
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => { setEffectiveEnd(e.target.value); }}
                    />
                </Grid>
                <Grid item md='3'>
                    <FormControl sx={{ marginTop: '-10px', marginBottom: '1px' }}>
                        <FormControlLabel
                            key="isPolicyCapped"
                            name="isPolicyCapped"
                            labelPlacement="start"
                            label="Policy Capped"
                            control={
                                <Checkbox
                                    checked={isPolicyCapped || false}
                                    onChange={(e) => { setIsPolicyCapped(e.target.checked); }}
                                />
                            }
                            sx={{ marginTop: '6px', minWidth: '90px' }}
                        />
                    </FormControl>
                </Grid>
                <Grid item md='3'>
                    <FormControl sx={{ marginTop: '-10px', marginBottom: '1px' }}>
                        <FormControlLabel
                            key="isRepayAgreementRequired"
                            name="isRepayAgreementRequired"
                            labelPlacement="start"
                            label="Repay Agreement Required"
                            control={
                                <Checkbox
                                    checked={isRepayAgreementRequired || false}
                                    onChange={(e) => { setIsRepayAgreementRequired(e.target.checked); }}
                                />
                            }
                            sx={{ marginTop: '6px', minWidth: '90px' }}
                        />
                    </FormControl>
                </Grid>
                <Grid item md='3'>
                    <FormControl sx={{ marginTop: '-10px', marginBottom: '1px' }}>
                        <FormControlLabel
                            key="isCostEstimateRequired"
                            name="isCostEstimateRequired"
                            labelPlacement="start"
                            label="Cost Estimate Required"
                            control={
                                <Checkbox
                                    checked={isCostEstimateRequired || false}
                                    onChange={(e) => { setIsCostEstimateRequired(e.target.checked); }}
                                />
                            }
                            sx={{ marginTop: '6px', minWidth: '90px' }}
                        />
                    </FormControl>
                </Grid>
            </Grid>
          )}
          
        </Box>
        <DialogActions sx={{ p: '1.25rem' }}>
          {isLoadingModal && <SpinnerComponent />}
          {!isLoadingModal && (
            <> 
              <Button onClick={() => { setCreateModalOpen(false); setIsChoosingCreationMethod(true); }}>Cancel</Button>
              <Button
                onClick={createPolicy}
                color="primary"
                type="submit"
                variant="contained"
                disabled={!isPolicyValid}
              >
                Create Policy
              </Button>
            </>
          )} 
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default compose(
  connect(null, {
    postClientRelocationPolicy,
    updateClientRelocationPolicy,
    getClientRelocationPoliciesByClientId,
    showToast
  }),
)(ClientRelocationPolicyTable);